import { render, staticRenderFns } from "./dialog-selectheader.vue?vue&type=template&id=6f35a7f4&"
import script from "./dialog-selectheader.vue?vue&type=script&lang=js&"
export * from "./dialog-selectheader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports